import styled from "styled-components"

const PageDot = styled.div<{ isSelected?: boolean }>`
  cursor: pointer;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.colors.greyDark : theme.colors.greyDisabled)};

  .slick-active > & {
    background-color: ${({ theme }) => theme.colors.greyDark};
  }
`

export default PageDot
